<template>
  <div>
    <basic-portlet v-if="activeDashboardNotifications.length" portlet-classes="pt-4 pb-1">
      <dashboard-notification v-for="notification in activeDashboardNotifications"
                              :key="notification.id" :notification="notification" />
    </basic-portlet>
    <div class="row">
      <div class="col-12 col-md-3">
        <basic-portlet title="Quick Start" icon="fa fa-bolt">
          <quick-start-bar />
        </basic-portlet>
      </div>
      <div v-if="analytics_enabled" class="col-12 col-md-9">
        <radar-highlights />
      </div>

      <div class="col-lg-6 d-none">
        <collapse-portlet v-if="!loading" title="Overview"
                          :expanded="true"
                          icon="flaticon2-list-2"
                          class="overview">
          <div class="kt-widget24">
            <div class="kt-widget24__details">
              <div class="kt-widget24__info">
                <a href="/items">
                  <h4 class="kt-widget24__title">
                    <i class="la la-file-audio-o" />
                    <span>Items </span>
                  </h4>
                  <span class="kt-widget24__desc">
                    Total amount of {{ getItemLabel() }}s
                  </span>
                </a>
              </div>
              <a href="/items">
                <span v-if="items_count" class="kt-widget24__stats kt-font-brand">
                  {{ items_count }}
                </span>
                <span v-else class="kt-widget24__stats kt-font-brand">
                  0
                </span>
              </a>
            </div>
          </div>
          <div class="kt-widget24">
            <div class="kt-widget24__details">
              <div class="kt-widget24__info">
                <a href="/feeds">
                  <h4 class="kt-widget24__title">
                    <i class="fa fa-rss" />
                    <span>{{ getFeedLabel(true) }} </span>
                  </h4>
                  <span class="kt-widget24__desc">
                    Total amount of {{ getFeedLabel() }}s
                  </span>
                </a>
              </div>
              <a href="/feeds">
                <span class="kt-widget24__stats kt-font-brand">
                  {{ feeds.length }}
                </span>
              </a>
            </div>
          </div>
          <!--end::Feeds -->
          <!--begin::Pending Uploads-->
          <div class="kt-widget24">
            <div class="kt-widget24__details">
              <div class="kt-widget24__info">
                <a href="/storage">
                  <h4 class="kt-widget24__title">
                    <i class="la la-thumbs-up" />
                    <span>Pending Uploads </span>
                  </h4>
                  <span class="kt-widget24__desc">
                    Files added by third-party uploads pending approval
                  </span>
                </a>
              </div>
              <a href="/storage">
                <span class="kt-widget24__stats kt-font-brand">
                  {{ pending_uploads.length }}
                </span>
              </a>
            </div>
          </div>
          <!--end::Pending Uploads -->
          <div class="kt-widget24">
            <storage-limit-progress-bar />
          </div>
        </collapse-portlet>
      </div>

      <div :class="analytics_enabled ? 'col-md-6 col-lg-7' : 'col-12 col-md-9'">
        <collapse-portlet :title="`${getFeedLabel(true)}s (${feeds.length})`" icon="fa fa-rss">
          <feed-grid />
        </collapse-portlet>
      </div>

      <div v-if="recorder_enabled" class="col-md-6 col-lg-5">
        <collapse-portlet v-if="!loading" title="Recordings" icon="fa fa-headphones">
          <div id="recording_accordion" class="accordion accordion-light  accordion-toggle-arrow">
            <div class="card">
              <div id="currently_recording_link" class="card-header">
                <div id="currently_recording_toggle" class="card-title"
                     data-toggle="collapse"
                     data-target="#currently_recording_body"
                     aria-expanded="true" aria-controls="currently_recording_body">
                  Currently Recording
                </div>
              </div>
              <div id="currently_recording_body" class="collapse show"
                   aria-labelledby="currently_recording_link"
                   data-parent="#recording_accordion">
                <div class="card-body">
                  <currently-recording />
                </div>
              </div>
            </div>
            <div id="quick_record_accordion" class="card">
              <div id="quick_record_link" class="card-header">
                <div class="card-title collapsed" data-toggle="collapse"
                     data-target="#quick_record_body"
                     aria-expanded="false" aria-controls="quick_record_body">
                  Quick Record
                </div>
              </div>
              <div id="quick_record_body" class="collapse"
                   aria-labelledby="quick_record_link"
                   data-parent="#recording_accordion">
                <div class="card-body">
                  <quick-record />
                </div>
              </div>
            </div>
            <div class="card">
              <div id="recent_10_recordings_link" class="card-header">
                <div class="card-title collapsed" data-toggle="collapse"
                     data-target="#recent_10_recordings_body"
                     aria-expanded="false" aria-controls="collapseFour2">
                  Recent 10 Recordings
                </div>
              </div>
              <div id="recent_10_recordings_body" class="collapse"
                   aria-labelledby="recent_10_recordings_body"
                   data-parent="#recording_accordion">
                <div class="card-body">
                  <recently-recorded />
                </div>
              </div>

              <div class="card">
                <div id="recordings_recording_soon_link" class="card-header">
                  <div class="card-title collapsed" data-toggle="collapse"
                       data-target="#recordings_recording_soon_body"
                       aria-expanded="false" aria-controls="recordings_recording_soon_link">
                    Recording soon
                  </div>
                </div>
                <div id="recordings_recording_soon_body" class="collapse"
                     aria-labelledby="recordings_recording_soon_body"
                     data-parent="#recording_accordion">
                  <div class="card-body">
                    <button style="float: right;" class="btn btn-xs" @click="reloadRecordingSoonData()">
                      <i class="flaticon2-refresh" />
                    </button>
                    <span> Within next </span>
                    <input v-model="recordings_soon_within_next_hours" @input="hideAlert">
                    <span> hours. Show max: </span>
                    <input v-model="recording_soon_limit">
                    <br><br>
                    <table v-if="recording_soon.length" class="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" />
                          <th scope="col">
                            Name
                          </th>
                          <th scope="col">
                            Stream
                          </th>
                          <th scope="col">
                            Fires At
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(recording, index) in recording_soon" :key="index">
                          <td>
                            <img v-if="recording.image !== null && urlType(recording.image)"
                                 style="width: 50px;" class="kt--img-rounded"
                                 :src="`${recording.image}`"
                                 title="file image">
                            <img v-else style="width: 50px;"
                                 class="kt--img-rounded" src="/build/media/misc/no-image.png"
                                 title="file image">
                          </td>
                          <td>
                            {{ recording.name }}
                          </td>
                          <td>
                            {{ recording.stream }}
                          </td>
                          <td>
                            {{ recording.broadcast_start | formatDateTime }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <div v-if="recording_soon_alert_visible" class="alert alert-ss-primary" role="alert">
                        <div class="alert-text">
                          No recordings are scheduled within the next <b>{{ recordings_soon_within_next_hours }}</b> hours.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <div id="recordings_publishing_soon_link" class="card-header">
                  <div class="card-title collapsed" data-toggle="collapse"
                       data-target="#recordings_publishing_soon_body"
                       aria-expanded="false" aria-controls="recordings_publishing_soon_link">
                    Publishing soon
                  </div>
                </div>
                <div id="recordings_publishing_soon_body" class="collapse"
                     aria-labelledby="recordings_publishing_soon_body"
                     data-parent="#recording_accordion">
                  <div class="card-body">
                    <table v-if="publishing_soon.length" class="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" />
                          <th scope="col">
                            Name
                          </th>
                          <th scope="col">
                            Publishing At
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(recording, index) in publishing_soon" :key="index">
                          <td>
                            <img v-if="recording.artwork !== null && !urlType(recording.artwork)"
                                 style="width: 50px;" class="kt--img-rounded"
                                 :src="`${recording.artwork.path}`"
                                 title="file image">
                            <img v-else-if="recording.image !== null && urlType(recording.image)"
                                 style="width: 50px;" class="kt--img-rounded"
                                 :src="`${recording.image}`"
                                 title="file image">
                            <img v-else style="width: 50px;"
                                 class="kt--img-rounded" src="/build/media/misc/no-image.png"
                                 title="file image">
                          </td>
                          <td>
                            <a target="_blank" title="open file location"
                               :href="`${timbre_player_url}/embed/item/${recording.uuid}`">
                              {{ recording.name }}</a>
                          </td>
                          <td>{{ recording.publish_start | formatDateTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <div class="alert alert-ss-primary" role="alert">
                        <div class="alert-text">
                          No Recordings Publishing Soon
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </collapse-portlet>
      </div>
    </div>
  </div>
</template>

<script>

import useRecorderStore from "VueStore/app/recorder";
import QuickRecord from "VuePartials/QuickRecord";
import CurrentlyRecording from "VuePartials/CurrentlyRecording";
import RecentlyRecorded from "VuePartials/Scheduler/RecentlyRecorded";
import StorageLimitProgressBar from "VuePartials/StorageLimitProgressBar";
import { mapActions } from "pinia";
import CollapsePortlet from "VueComponents/CollapsePortlet.vue";
import toastr from 'toastr';
import QuickStartBar from "VuePartials/QuickStart/QuickStartBar";
import FeedGrid from "VuePartials/Home/FeedGrid";
import DashboardMixin from "VueMixins/DashboardMixin";
import RadarHighlights from "VuePartials/Home/RadarHighlights.vue";

export default {
  components: {
    QuickStartBar,
    QuickRecord,
    CurrentlyRecording,
    StorageLimitProgressBar,
    CollapsePortlet,
    RecentlyRecorded,
    FeedGrid,
    RadarHighlights,
  },
  filters: {
    recordingType: function (value) {
      if (value == "once") {
        return "One-Off";
      } else {
        return "Recurring";
      }
    },
  },
  mixins: [DashboardMixin],
  data: () => ({
    recorder_enabled: true,
    recording_soon: window.recording_soon,
    publishing_soon: window.publishing_soon,
    pending_uploads: window.pending_uploads,
    streams: [],
    items_count: window.items_count,
    timbre_player_url: window.timbre_player_url,
    stream: "",
    recordings_soon_within_next_hours: 10,
    recording_soon_limit: 10,
    recording_soon_alert_visible: false,
  }),
  computed: {
    latestStorageItemsFilter() {
      const five_days_ago = moment()
        .subtract(5, "days")
        .format("YYYY-MM-DD");

      return `created_at:gt:${five_days_ago}`;
    },
  },
  created() {
    this.recorder_enabled = this.permissionsCanAccessFeature('recorder');
  },
  mounted() {
    this.listStreams();
    if (this.recorder_enabled) {
      this.getRecordings();
    }
    EventBus.$on("recording_started", () => $('#currently_recording_toggle').click());
    this.loading = false;
  },
  methods: {
    ...mapActions(useRecorderStore, ["getRecordings"]),

    // Reload recording schedule by getting fresh data and then returning from cache
    async reloadRecordingSoonData() {
      if (this.recording_soon_limit <= 0 || this.recording_soon_limit > 20) {
        toastr.error('Please input value between 1 and 20');

        return;
      }

      this.recording_soon_alert_visible = true;

      try {
        KTApp.blockPage();
        await axios.get(`/api/v1/scheduler`, {
          params: {
            cache: new Date().valueOf(),
            forget: true,
          },
        });
        this.recording_soon = (await axios.get('/api/v1/scheduler/recordingsoon', {
          params: {
            'within_hours': this.recordings_soon_within_next_hours ?? 10,
            'limit': this.recording_soon_limit ?? 10,
          },
        })).data;
        KTApp.unblockPage();
      } catch (error) {
        window.handleAxiosError(error);
        this.recording_soon = [];
        KTApp.unblockPage();
      }
    },

    urlType(url_string) {
      const pat = /^https?:\/\//i;
      if (pat.test(url_string)) {
        return true;
      }
      return false;
    },
    feedImage(feed) {
      if (feed.feed_artwork_thumbnail_url) {
        return feed.feed_artwork_thumbnail_url;
      }

      return "//placehold.it/150";
    },
    async listStreams() {
      try {
        KTApp.block("#quick_record_accordion", {});
        const streams = (await axios.get("/api/v1/streams"))?.data?.data?.streams;
        KTApp.unblock("#quick_record_accordion", {});
        this.streams = _.map(streams, "name");
      } catch (err) {
        this.handleAxiosError(err);
      }
    },

    hideAlert() {
      this.recording_soon_alert_visible = false;
    },

  },

};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "~AssetsSass/_variables" as *;

.reach-header {
  font-size:1.2em;
}

.kt-widget4 .kt-widget4__item .kt-widget4__number {
  width:4rem;
}

td {
  vertical-align: middle;
}

.overview {
  :deep(i) {
    color: map.get($ss, 'primary');
  }
}

.feed-actions {
  a {
    width: 100%;
  }
}
#storage_accordion {
  .kt-accordion__item-content {
    padding: 1.5rem 1rem;
  }
}
.kt-portlet__head a {
  color: map.get($ss-theme, 'hunter-grey');
}
.card-header {
  font-weight:bold;
}
.card,
.storage-info {
  margin-bottom: 2em;
}

.VueCarousel-slide {
  padding: 0 1rem 0 0;
}

.VueCarousel-dot-container {
  margin-top: 0 !important;
}
</style>
